module.exports = __webpack_public_path__ + "static/media/Logo_retim_couleur.d7806f53.svg";